// Credibility Band Content Configuration
// Used for displaying trust indicators and social proof on landing pages

export const CREDIBILITY_CONTENT = {
  headline: "Built on Proven Islamic Financing — Not Theory",
  description: "HalalCred is powered by a strategic partnership with <strong>Craft3</strong>, which has been originating and servicing Shariah-compliant financing since 2019.",
  trackRecordTitle: "Craft3 Islamic Financing Track Record:",
  metrics: [
    "$20+ million in Islamic-compliant financing originated",
    "$15+ million in new Islamic financing projected for 2026",
    "$63 million in community commercial real estate enabled through local ownership",
    "100% portfolio performance aligned with agreed terms",
    "10,000+ low-income families and community members impacted",
    "Multiple Islamic financing products in active use (real estate & small business)"
  ],
  closingStatement: "<strong>HalalCred</strong> extends this <b>battle-tested model</b> nationally — so partners and customers can move forward with confidence"
};

